import { logEvent } from "@src/appV2/lib/analytics";
import { USER_EVENTS } from "@src/constants";

export const logAccountPageMenuItemTapped = (menuItemName: string) => {
  logEvent(USER_EVENTS.TAPPED_ACCOUNT_MENU_ITEM, { menuItemName });
};
